module.exports = __webpack_public_path__ + "img/logo-juancito-pinto-2026.043a8a8d.png";